import { alpha, createStyles, Theme } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      display: 'block',
      cursor: 'pointer',
      outline: `2px solid transparent`,
      borderRadius: 8,
      padding: spacing(0.5),
      height: 36,
      width: 36,
      transition: 'outline 0.2s ease-in-out',

      '&:hover': {
        outline: `2px solid ${alpha(colours.solid.white, 0.3)}`,
      },
    },
    rootActive: {
      cursor: 'default',
      outline: `2px solid ${alpha(colours.solid.white, 0.65)}`,
      pointerEvents: 'none',

      '&:hover': {
        outline: `2px solid ${alpha(colours.solid.white, 0.65)}`,
      },
    },
    icon: {
      '& svg': {
        height: 32,
        width: 32,
      },
    },
  });
